import { createContext, ReactNode, useContext, useState } from 'react';

interface Props {
  children: ReactNode;
}

const ApiErrorContext = createContext({ 
  error: 0, 
  setErrorCode: (statusCode: any) => {} 
});

export const ApiErrorProvider = ({children}: Props) => {
  const [error, setError] = useState(0);

  const setErrorCode = (statusCode: number) => {
    if (error) return;
    setError(statusCode);
  };
  
  return (
    <ApiErrorContext.Provider 
      value={{ 
        error, 
        setErrorCode 
      }}
    >
      {children}
    </ApiErrorContext.Provider>
  );
};
  
export const useApiError = () => {
  return useContext(ApiErrorContext);
};